/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

/**
 * Check if the given object is an iterator.
 *
 * ```ts
 * isIterable([1, 2, 3].values()); // true
 * isIterable([1, 2, 3]); // true
 * isIterable('abc'); // true
 * isIterable(new Map()); // true
 * isIterable(new Set()); // true
 * isIterable(new WeakMap()); // false
 * isIterable(123); // false
 * isIterable({}); // false
 * isIterable(null); // false
 * ```
 */
export const isIterable = <T = any>(mixed: any): mixed is Iterable<T> => {
  return mixed !== null && mixed !== undefined && typeof mixed[Symbol.iterator] === 'function';
};
